module.exports = __webpack_public_path__ + "static/img/site-jinkan.fc9f772.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/works/site-jinkan.jpg
 ** module id = 25
 ** module chunks = 1
 **/